import { useEffect } from 'react';

const APP_TITLE = 'FlowQA';
const DEFAULT_DESCRIPTION =
  'Track execution runs, quality trends, and releases with project-aware test analytics.';

const buildPageTitle = (title?: string): string => {
  const trimmedTitle = title?.trim() ?? '';
  if (!trimmedTitle) {
    return APP_TITLE;
  }
  if (trimmedTitle === APP_TITLE || (trimmedTitle.startsWith('[') && trimmedTitle.endsWith(']'))) {
    return trimmedTitle;
  }
  return `${trimmedTitle} · ${APP_TITLE}`;
};

export const usePageTitle = (title?: string): void => {
  useEffect(() => {
    document.title = buildPageTitle(title);
  }, [title]);
};

const getOrCreateMetaDescriptionTag = (): HTMLMetaElement => {
  const existingTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (existingTag) {
    return existingTag;
  }
  const tag = document.createElement('meta');
  tag.setAttribute('name', 'description');
  document.head.appendChild(tag);
  return tag;
};

export const usePageMetadata = (title?: string, description?: string): void => {
  useEffect(() => {
    document.title = buildPageTitle(title);
    const descriptionTag = getOrCreateMetaDescriptionTag();
    const resolvedDescription = description?.trim();
    descriptionTag.setAttribute(
      'content',
      resolvedDescription && resolvedDescription.length > 0
        ? resolvedDescription
        : DEFAULT_DESCRIPTION,
    );
  }, [description, title]);
};
